import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 保有資格リポジトリ
const enterpriseCrewHavingLicenseRepository = AiseaApiFactory.get(
  "enterpriseCrewHavingLicense"
);

// 資格定義リポジトリ
const enterpriseCrewLicenseRepository = AiseaApiFactory.get(
  "enterpriseCrewLicense"
);

/**
 * 保有資格サービス
 */
const CrewHavingLicenseService = (() => {
  /**
   * 保有資格一覧を取得
   * @param {String} enterpriseCrewId - 船員ID
   * @param {Object} payload - 検索パラメータ
   * @returns {Promise<Array>} 保有資格の配列
   */
  const fetchList = async (enterpriseCrewId, payload) => {
    const res = await enterpriseCrewHavingLicenseRepository.fetchList(
      enterpriseCrewId,
      payload
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  /**
   * 保有資格を取得
   * @param {String} enterpriseCrewId - 船員ID
   * @param {String} id - 保有資格ID
   * @returns {Promise<Object>} 保有資格データ
   */
  const fetchById = async (enterpriseCrewId, id) => {
    const res = await enterpriseCrewHavingLicenseRepository.fetchById(
      enterpriseCrewId,
      id
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  /**
   * 保有資格を新規登録
   * @param {String} enterpriseCrewId - 船員ID
   * @param {Object} payload - 登録データ
   * @returns {Promise<Object>} 登録後のデータ
   */
  const add = async (enterpriseCrewId, payload) => {
    const res = await enterpriseCrewHavingLicenseRepository.add(
      enterpriseCrewId,
      payload
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  /**
   * 保有資格を更新
   * @param {String} enterpriseCrewId - 船員ID
   * @param {String} id - 保有資格ID
   * @param {Object} payload - 更新データ
   * @returns {Promise<Object>} 更新後のデータ
   */
  const update = async (enterpriseCrewId, id, payload) => {
    const res = await enterpriseCrewHavingLicenseRepository.update(
      enterpriseCrewId,
      id,
      payload
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  /**
   * 保有資格を削除
   * @param {String} enterpriseCrewId - 船員ID
   * @param {String} id - 保有資格ID
   * @returns {Promise<Object>} 削除結果
   */
  const deleteById = async (enterpriseCrewId, id) => {
    const res = await enterpriseCrewHavingLicenseRepository.delete(
      enterpriseCrewId,
      id
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  return {
    fetchList,
    fetchById,
    add,
    update,
    deleteById,
  };
})();

/**
 * 資格定義サービス
 */
const CrewLicenseService = (() => {
  /**
   * 資格定義一覧を取得
   * @param {Object} payload - 検索パラメータ
   * @returns {Promise<Array>} 資格定義の配列
   */
  const fetchList = async payload => {
    const res = await enterpriseCrewLicenseRepository.fetchList(payload);
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  return {
    fetchList,
  };
})();

export default CrewHavingLicenseService;
export { CrewLicenseService };
